module.exports = __webpack_public_path__ + "static/media/doc-01-host.d61f8675.svg";